<ng-template #revokeConfirmContent>
  <b>{{ revokeTarget }}</b>
</ng-template>

<section class="api-tokens__section">
  <h3>{{ "admin.api-tokens.my-token.title" | translate }}</h3>
  <p class="api-tokens__hint">{{ "admin.api-tokens.my-token.hint" | translate }}</p>

  <nz-spin [nzSpinning]="myTokenLoading">
    <div class="api-tokens__my-token">
      <span *ngIf="myToken" class="api-tokens__token-value">{{ shortenToken(myToken) }}</span>
      <span *ngIf="hasNoToken" class="api-tokens__token-value api-tokens__token-value--empty">
        {{ "admin.api-tokens.my-token.none" | translate }}
      </span>
      <span *ngIf="myTokenFailed" class="api-tokens__token-value api-tokens__token-value--empty">
        {{ "admin.api-tokens.my-token.unknown" | translate }}
      </span>

      <button nz-button nzType="primary" [nzLoading]="generating" [disabled]="!canGenerate" (click)="onGenerate()">
        {{ (myToken ? "admin.api-tokens.regenerate.btn" : "admin.api-tokens.generate.btn") | translate }}
      </button>

      <button *ngIf="myTokenFailed" nz-button nzType="default" (click)="fetchMyToken()">
        {{ "admin.api-tokens.retry.btn" | translate }}
      </button>

      <button
        *ngIf="myToken"
        nz-button
        nzType="default"
        nzDanger
        [nzLoading]="revoking"
        [disabled]="mutating"
        (click)="onRevokeMyToken()"
      >
        {{ "admin.api-tokens.revoke.btn" | translate }}
      </button>
    </div>
  </nz-spin>
</section>

<ng-container *ngIf="canViewAllTokens">
  <nz-divider></nz-divider>

  <section class="api-tokens__section">
    <h3>{{ "admin.api-tokens.all.title" | translate }}</h3>

    <div *ngIf="tokensFailed" class="api-tokens__error">
      <span>{{ "admin.api-tokens.all.error" | translate }}</span>
      <button nz-button nzType="default" (click)="fetchAllTokens()">
        {{ "admin.api-tokens.retry.btn" | translate }}
      </button>
    </div>

    <nz-table
      *ngIf="!tokensFailed"
      class="sticky-table"
      [nzScroll]="{ x: '1200px' }"
      #tokensTable
      [nzData]="tokens"
      nzSize="small"
      nzShowSizeChanger="true"
      [nzLoading]="loading"
      [nzNoResult]="'admin.api-tokens.empty' | translate"
    >
      <thead>
        <tr>
          <th nzColumnKey="EMAIL" [nzSortFn]="sortByEmail">{{ "admin.email.title" | translate }}</th>
          <th nzColumnKey="TOKEN">{{ "admin.api-tokens.token.title" | translate }}</th>
          <th nzColumnKey="CREATED" [nzSortFn]="sortByCreated">{{ "admin.api-tokens.created.title" | translate }}</th>
          <th nzColumnKey="LAST_USED" [nzSortFn]="sortByLastUsed" nzSortOrder="descend">
            {{ "admin.api-tokens.last-used.title" | translate }}
          </th>
          <th>{{ "admin.action.title" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of tokensTable.data">
          <td>{{ data.email || "-" }}</td>
          <td class="api-tokens__token-value">{{ shortenToken(data.obfuscatedToken) }}</td>
          <td>{{ data.created ? (data.created | date : "yyyy-MM-dd HH:mm:ss") : "-" }}</td>
          <td>
            <span *ngIf="data.lastUsed">{{ data.lastUsed | date : "yyyy-MM-dd" }}</span>
            <span *ngIf="!data.lastUsed" class="api-tokens__never">
              {{ "admin.api-tokens.last-used.never" | translate }}
            </span>
          </td>
          <td class="nowrap">
            <button
              nz-button
              nzType="link"
              nzSize="small"
              [nzTooltipTitle]="data.accountId"
              nzTooltipPlacement="top"
              nz-tooltip
              [attr.aria-label]="'admin.copy-id.label' | translate"
              (click)="copyAccountId(data.accountId)"
            >
              <span nz-icon nzType="info-circle" nzTheme="outline"></span>
            </button>

            <button
              nz-button
              nzType="link"
              nzSize="small"
              [nzTooltipTitle]="'admin.api-tokens.revoke.tooltip' | translate"
              nzTooltipPlacement="top"
              nz-tooltip
              [attr.aria-label]="'admin.api-tokens.revoke.tooltip' | translate"
              [disabled]="mutating"
              (click)="onRevokeToken(data)"
            >
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </section>
</ng-container>
